import './MainHome.scss';
import Categoryitem from '../../app-components/Categoryitem';
import Productitem from '../../app-components/Productitem';
import Storeitem from '../../app-components/Storeitem';
import ShimmerC from '../../app-components/ShimmerC';
import CustomerReview from '../../app-components/CustomerReview';
import CFooter from '../../app-components/CFooter';
import { IoChevronForwardCircleSharp } from "react-icons/all";
import React, { useEffect, useState,useRef } from 'react';
import axios from "axios";
import Carousel from 'react-bootstrap/Carousel'
import { Link, useHistory } from 'react-router-dom'
import CHeader from '../../app-components/CHeader';
import BannerImage from '../../assets/banner.jpg'
import {globleAPI as Global} from '../../globals'
import slugify from 'react-slugify';

function MainHome(props:any) {

  const [shortcutIcon, setshortcutIcon] = useState<any[]>([])
  const [popularProduct, setpopularProduct] = useState<any[]>([])
  const [top10StoresList, settop10StoresList] = useState<any[]>([])
  const [featuredstore1, setfeaturedstore1] = useState<any[]>([])
  const [featuredstore1name, setfeaturedstore1name] = useState<any[]>([])
  const [featuredstore2, setfeaturedstore2] = useState<any[]>([])
  const [featuredstore3, setfeaturedstore3] = useState<any[]>([])
  const [featuredstore3name, setfeaturedstore3name] = useState<any[]>([])
  const [featuredstore2name, setfeaturedstore2name] = useState<any[]>([])
  const [featuredstore1store_pic, setfeaturedstore1store_pic] = useState<any[]>([])
  const [featuredstore2store_pic, setfeaturedstore2store_pic] = useState<any[]>([])
  const [featuredstore3store_pic, setfeaturedstore3store_pic] = useState<any[]>([])
  const [Brands, setBrands] = useState<any>([])
  const [LuxuryProduct, setLuxuryProduct] = useState<any[]>([])
  const [LuxuryProductsss, setLuxuryProductsss] = useState<any[]>([])
  const [scrollToFooter, setscrollToFooter] = useState(false)
  const [sliderImages, setsliderImages] = useState<any[]>([])
  const [localdata, setlocaldata] = useState(localStorage.getItem('myData3') || '')
  const [token] = useState(localStorage.getItem('token') || '')
  const history = useHistory();
  const scrollToRef = (ref: any) => window.scrollTo(0, ref.current.offsetTop)
  const myRef = useRef(null)
  const getTheApp = useRef(null)
  const executeScroll = () => scrollToRef(myRef)
  const executeScrollApp = () => scrollToRef(getTheApp)

  useEffect(() => {
    history.listen((location, action) => {
      window.location.reload() 
  })

  if(props.location.state == 'review'){
    executeScroll()
    
  }else if(props.location.state == 'gettheapp'){
    executeScrollApp()
  }else{
    window.scrollTo(0, 0)
  }
    getAllBrands()
    getShortcutIcons()
    getPopularProducts()
    getStoresList()
    getLuxuryProducts()
    getAnnoucments()
    getLuxuryCategory()
    getStoreWithProducts()
  }, []);

  var FeaturedStore: string = 'yes';
  var nofeaturedstore: string = 'No';
  var to: string = 'No';
  let page = 1

  const getLuxuryCategory = () => {
    axios
      .get(Global.GET_LUXURY_CATEGORIES)
      .then(response => {
        let luxury = response.data.luxury_categories.filter(
          (Industrydata: any, idx: any) => idx < 6,
        );
        setLuxuryProduct(luxury)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const getAllBrands = () => {
    axios
      .get(Global.GET_POPULAR_BRANDS)
      .then(response => {
        setBrands(response.data.popularbrands)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const getAnnoucments = () => {
    axios
      .get(Global.GET_CASH_DATA)
      .then(response => {
        console.log('lesgemmdflsdf',response)
        setsliderImages(response.data.slider_array)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const getLuxuryProducts = () => {
    axios
      .get(Global.GET_LUXURY_PRODUCTS)
      .then(response => {
        let luxury = response.data.luxury_products.filter(
          (Industrydata: any, idx: any) => idx < 6,
        );
        setLuxuryProductsss(luxury)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const getShortcutIcons = () => {
    axios
      .get(Global.GET_APP_SHORTCUT_ICONS)
      .then(response => {
        setshortcutIcon(response.data.app_shortcut_icons)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const getPopularProducts = () => {
    axios
      .get(Global.GET_POPULAR_PRODUCTS)
      .then(response => {
        let industry = response.data.stores.filter(
          (Industrydata: any, idx: any) => idx < 6,
        );
        setpopularProduct(industry)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const getStoresList = () => {
    axios
      .get(Global.GET_ALL_RETAIL_STORES_TOP_ITEM)
      .then(response => {
        let stores = response.data.stores.filter(
          (Industrydata: any, idx: any) => idx < 6,
        );
        settop10StoresList(stores)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const getStoreWithProducts = () => {
    axios
      .get(Global.GET_STORES_WITH_PRODUCTS)
      .then(response => {
        setfeaturedstore1(response.data.stores1)
        setfeaturedstore1name(response.data.stores1[0].store_name)
        setfeaturedstore3name(response.data.stores3[0].store_name)
        setfeaturedstore1store_pic(response.data.stores1[0].store_pic)
        setfeaturedstore2(response.data.stores2)
        setfeaturedstore3(response.data.stores3)
        setfeaturedstore2name(response.data.stores2[0].store_name)
        setfeaturedstore2store_pic(response.data.stores2[0].store_pic)
        setfeaturedstore3store_pic(response.data.stores3[0].store_pic)
      })
      .catch(function (error) {
        console.log('response if the api is errror =', error)
      });
  }

  const moving = (data: any) => {
    history.push('/all-products', [data, 'Home']);
  };

  const movingLuxuryCategorey = (data: any) => {
    history.push('/luxury-products-category', [data]);
  };
  const movingLuxury = (data: any) => {
    history.push('/luxury-products', [data]);
  };

  const moveToDetailScreen = (data: any) => {
    history.push('/product-detail/'+data.id + '/'+slugify(data.name), [data]);
  }

  const moveToStores = (data: any) => {
    history.push('/stores', [data]);
  }

  const move = (data: any) => {
    history.push('/StoreDetail', [data]);
  }

  const movetoStoreDetail = (data: any) => {
    history.push('/StoreDetail', [data]);
  }
  const movetoAllProducts = (data: any) => {
    console.log('dfasdfsdfads',data)
    if(data.name == 'Dresses' || data.name == 'Tops'  ){
history.push('/all-products', ['AllCatSubCat',data.category_id,data.sub_category_id]);
   
}else if(data.name == 'Daily Deals Top Brands'){
  history.push('/all-products', ['AllSale']);
}else if(data.name == 'Daily Deals Luxury'){
  history.push('/luxury-products', ['AllSaleLuxury']);
}else if(data.name == 'Preloved Luxury'){
  history.push('/luxury-products', ['usedItems',]);
}else if(data.name == 'Preloved Brands'){
  history.push('/all-products', ['usedItems',]);
}else {
  history.push('/all-products', ['itemCat',data.category_id]);
}
  }
  const movetoGetApp = (data: any) => {
 if(data == 'get the app'){
  setscrollToFooter(true)
 }
  }
 
  return (
    <div>
      <CHeader movetoGetApp={movetoGetApp}  ></CHeader>
      <div className=" " style={{zIndex:-1}} >
              {sliderImages.length >= 1 ? (
                <Carousel>
          {sliderImages?.map((images ,index) => (
            <Carousel.Item key={index} >
              <img  className="header-image-styling  img-responsive " src={images} alt="First slide" />
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <div>
          <ShimmerC smallshimer='no' />
        </div>
        )}
        </div>
        
      {shortcutIcon.length >= 1 ? (
        <div  className='category-container' style={{ justifyContent: 'space-evenly' }} >
          <Categoryitem  movetoAllProducts={movetoAllProducts} Dataof={shortcutIcon} />
        </div>
      ) : (
        <ShimmerC smallshimer='yes' />
      )}
      <div className='page-left-padding page-right-padding' >
        <div className='contentStyle cm-t-30'>
          <div className='mainHeading '>  Popular Products  </div>
          <div className='  d-flex touchAble bg-color-primary page-color f-15 main-font f-500 border-radius cp-t-6 cp-b-6 cp-l-10 cp-r-10 '>
            <div className="cp-r-5 align-self-center d-flex" >
              <label className="f-15 cp-l-10  main-font label" style={{color:'white'}} >  <Link to="/popular-products" className="link label" style={{ color: 'white' }} >View All</Link></label>
            </div>
            <div className="align-self-center d-flex ">
            <IoChevronForwardCircleSharp size='1.5rem' />
            </div>
          </div> 
        </div>
        {popularProduct.length >= 1 ? (
          <div className='row '>
            {popularProduct.map((person: any, index) => (
              <div key={person.id} onClick={() => moveToDetailScreen(person)} className='col-md-2 col-sm-6 col-6 '   >
                <Productitem DataofProduct={person} />
              </div>
            ))}
          </div>
        ) : (
          <div className='row '>
            <ShimmerC homeproducts='yes' />
          </div>
        )}
        <div className='contentStyle'>
          <label className="mainHeading" >Featured Stores</label>
          </div>
        {featuredstore1.length >= 1 ? (
          <div>
            <div className='display-flex content-between align-item-center'>
              <div  onClick={()=>movetoStoreDetail(featuredstore1[0].user_id)} className=' cp-t-1rem cp-b-1rem   display-flex align-item-center'>
                <img className='shop-img-style' src={'https://lesfemmestesting.dominioninc.org/public/uploads/thumbnail/'+featuredstore1store_pic}></img>
                <div className='f-20 main-font primary-color cp-l-1rem font-weight-bold'>
                  {featuredstore1name}
                </div>
              </div>
            
          <div onClick={()=>movetoStoreDetail(featuredstore1[0].user_id)} className='  d-flex touchAble bg-color-primary page-color f-15 main-font f-500 border-radius cp-t-6 cp-b-6 cp-l-10 cp-r-10 '>
            <div className="cp-r-5 align-self-center d-flex" >
              <label className="f-15 cp-l-10  main-font label" style={{color:'white'}} >  View All</label>
            </div>
            <div className="align-self-center d-flex ">
            <IoChevronForwardCircleSharp size='1.5rem' />
            </div>
          </div> 

              
            </div>
            <div className='row '>
              {featuredstore1.map((person: any) => (
                <div key={person.id} onClick={() => moveToDetailScreen(person)} className='col-md-2 col-sm-6 col-6'>
                  <Storeitem DataofProduct={person} FeaturedStores={FeaturedStore} />
                </div>
              ))
              }
            </div>
          </div>
        ) : (
          <div>
            <ShimmerC pictureIcon='yes' />
            <div className='row ' >
              <ShimmerC homeproducts='yes' />
            </div>
          </div>
        )}
        {featuredstore3.length >= 1 ? (
          <div>
            <div className='display-flex content-between align-item-center'>
              <div onClick={()=>movetoStoreDetail(featuredstore3[0].user_id)} className=' cp-t-1rem cp-b-1rem display-flex align-item-center'>
              <img className='shop-img-style' src={'https://lesfemmestesting.dominioninc.org/public/uploads/thumbnail/'+featuredstore3store_pic}></img>
                <div className='f-20 main-font primary-color cp-l-1rem text-truncate font-weight-bold'>
                  {featuredstore3name.slice(0, 15)}
                </div>
              </div>
             
          <div onClick={()=>movetoStoreDetail(featuredstore3[0].user_id)} className='  d-flex touchAble bg-color-primary page-color f-15 main-font f-500 border-radius cp-t-6 cp-b-6 cp-l-10 cp-r-10 '>
            <div className="cp-r-5 align-self-center d-flex" >
              <label className="f-15 cp-l-10  main-font label" style={{color:'white'}} >  View All</label>
            </div>
            <div className="align-self-center d-flex ">
            <IoChevronForwardCircleSharp size='1.5rem' />
            </div>
          </div> 

             
            </div>
            <div className='row '>
              {featuredstore3.map((person: any) => (
                <div key={person.id} onClick={() => moveToDetailScreen(person)} className='col-md-2 col-sm-6 col-6'>
                  <Storeitem DataofProduct={person} FeaturedStores={FeaturedStore} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="cm-t-60" >
            <ShimmerC pictureIcon='yes' />
            <div className='row ' >
              <ShimmerC homeproducts='yes' />
            </div>
          </div>
        )}
        {featuredstore2.length >= 1 ? (
          <div>
            <div className='cp-t-1rem  display-flex content-between align-item-center'>
              <div onClick={()=>movetoStoreDetail(featuredstore2[0].user_id)} className='cp-t-1rem cp-b-1rem  display-flex align-item-center'>
              <img className='shop-img-style' src={'https://lesfemmestesting.dominioninc.org/public/uploads/thumbnail/'+featuredstore2store_pic}></img>
                <div className='f-20 main-font primary-color cp-l-1rem text-truncate font-weight-bold'>
                  {featuredstore2name.slice(0, 15)}
                </div>
              </div>
          <div onClick={()=>movetoStoreDetail(featuredstore2[0].user_id)} className='  d-flex touchAble bg-color-primary page-color f-15 main-font f-500 border-radius cp-t-6 cp-b-6 cp-l-10 cp-r-10 '>
            <div className="cp-r-5 align-self-center d-flex" >
              <label className="f-15 cp-l-10  main-font label" style={{color:'white'}} >  View All</label>
            </div>
            <div className="align-self-center d-flex ">
            <IoChevronForwardCircleSharp size='1.5rem' />
            </div>
          </div> 
             
            </div>
            <div className='row '>
              {featuredstore2.map((person: any) => (
                <div key={person.id} onClick={() => moveToDetailScreen(person)} className='col-md-2 col-sm-6 col-6'>
                  <Storeitem DataofProduct={person} FeaturedStores={FeaturedStore} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="cm-t-60" >
            <ShimmerC pictureIcon='yes' />
            <div className='row ' >
              <ShimmerC homeproducts='yes' />
            </div>
          </div>
        )}

{Brands.length >= 1 ? (
        <div className="cp-t-2rem" > 
              <div className='mainHeading d-flex justify-content-center'>  Popular Brands </div>
          <Categoryitem Dataof={Brands} brands={true} />
          <div className="d-flex flex-row-reverse page-left-padding page-right-padding " >
      <label className=' label touchAble primary-color underline  '  >    <Link to="/brands" className="link primary-color" style={{  border: 0 }} > See All Brands</Link>  </label>
      </div>
        </div>
      ) : (
        <ShimmerC smallshimer='yes' />
      )}

        <div className='contentStyle'>
          <div className='mainHeading'>
            Luxury Items
          </div>
        </div>
        {LuxuryProductsss.length >= 1 ? (
          <div>

          <div className='row '>
            {LuxuryProductsss.map((person: any) => (
              <div key={person.id} onClick={() => moveToDetailScreen(person)} className='col-md-2 col-sm-6 col-6'>
                <Storeitem DataofProduct={person} FeaturedStores={FeaturedStore} />
              </div>
            ))}
          </div>
          <div  onClick={()=>movingLuxury('Luxury Products')} className="d-flex flex-row-reverse cp-t-2rem" >
             <div   className=' touchAble bg-color-primary page-color f-15 main-font f-500 border-radius cp-t-6 cp-b-6 cp-l-10 cp-r-10 '>
              <label className="primary-color f-15 cp-l-10  main-font label" >  <a className="link label" style={{ color: 'white', border: 0 }} >View All</a> </label>
            <span> <IoChevronForwardCircleSharp size='1.6rem' /></span>
          </div>
          </div>          
            </div>
        ) : (
          <div className='row '>
            <ShimmerC homeproducts='yes' />
          </div>
        )}
        <div className='contentStyle'>
          <div className='mainHeading'> Luxury Categories  </div>
        </div>
        {LuxuryProduct.length >= 1 ? (
          <div className='row '>
            {LuxuryProduct.map((person: any) => (
              <div key={person.id}  onClick={() => movingLuxuryCategorey(person)} className='col-md-4 col-sm-12 col-12'>
                <Categoryitem DataofProduct={person} type='largecategory' />
              </div>
            ))
            }
          </div>
        ) : (
            <div className="d-flex flex-row" >
            <ShimmerC LuxuryCate='yes' />
            </div>
        )}
        <div className='contentStyle'>
          <div className='mainHeading'>  Retail Stores  </div>
          <div onClick={() => moveToStores('Retail Stores')} className='pointer bg-color-primary page-color f-15 main-font f-500 border-radius cp-t-6 cp-b-6 cp-l-10 cp-r-10 '>
            Browse more stores
            <span> <IoChevronForwardCircleSharp size='1.6rem' /></span>
          </div>
        </div>
        {top10StoresList.length >= 1 ? (
          <div className='row '>
            {top10StoresList.map((stores: any) => (
              <div key={stores.id} onClick={()=>move(stores.id)} className='col-md-2 col-sm-6 col-6'>
                <Storeitem DataofProduct={stores} FeaturedStore={nofeaturedstore} />
              </div>
            ))
            }
          </div>
        ) : (
          <div className='row '>
            <ShimmerC homeproducts='yes' />
          </div>
        )}
        <div className='contentStyle'>
          <div className='mainHeading'>
            Preloved Stores
          </div>
          <div onClick={() => moveToStores('Preloved Stores')} className='pointer bg-color-primary page-color f-15 main-font f-500 border-radius cp-t-6 cp-b-6 cp-l-10 cp-r-10 '>
            Browse more stores
            <span> <IoChevronForwardCircleSharp size='1.5rem' /></span>
          </div>
        </div>
        {top10StoresList.length >= 1 ? (
          <div className='row '>
            {top10StoresList.map((person: any) => (
              <div key={person.id} className='col-md-2 col-sm-6 col-6'>
                <Storeitem DataofProduct={person} FeaturedStore={nofeaturedstore} />
              </div>
            ))}
          </div>
        ) : (
          <div className='row '>
            <ShimmerC homeproducts='yes' />
          </div>
        )}
        <div ref={myRef}>
          <div className='contentStyle '>
            <label className="f-25 main-font" >
            Reviews from Buyers and Sellers
            </label>
          </div>
          <div>
            <div className="cp-b-3rem" >
              <Carousel   >
                <Carousel.Item >
                  <CustomerReview ReviewPage='1' />
                </Carousel.Item>
                <Carousel.Item  >
                  <CustomerReview ReviewPage='2' />
                </Carousel.Item>
                <Carousel.Item  >
                  <CustomerReview ReviewPage='3' />
                </Carousel.Item>
              </Carousel>
              <div className='col-md-4'>
                {page == 2 ? (
                  <CustomerReview ReviewPage='2' />
                ) : null}
              </div>
              <div className='col-md-4'>
                {page == 3 ? (
                  <CustomerReview ReviewPage='3' />
                ) : null}
              </div>
              <div style={{ backgroundColor: 'red', display: 'flex' }} >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img className='download-image-styling img-responsiv' useMap="#workmap" src={BannerImage} ></img>
      </div>
      <map name="workmap">
      <area  alt="" target="_blank" title="" href="https://play.google.com/store/apps/details?id=com.lesfemmes&amp;amp;hl=en" coords="103,266,383,344" shape=""></area>
    <area  alt=""  target="_blank" title="" href="https://apps.apple.com/pk/app/lesfemmes/id1396175773" coords="713,340,442,267" shape=""></area>
</map>  
      <div    className='text-center cp-t-2rem  cp-b-2rem '>
        <div className='mainHeading'>
          Join Our NewsLetter
        </div>
        <div className=' labelText cp-b-1rem'>
          Sign up for our newsletter and don't miss a thing!
        </div>
        <input className='subscriptinput' placeholder='Enter your email address'></input>
        <span className='sub-btn capitalize font-weight-bold'>Subscribe</span>
      </div>
      <div ref={getTheApp}></div>
      <div className="c-border-top-light">
        < CFooter   scrollToFooter={scrollToFooter} />
      </div>
      
    </div  >
  );
}

export default MainHome;
